// extracted by mini-css-extract-plugin
module.exports = {"backgroundImageHolder":"purify_index__backgroundImageHolder--35tGg","showG176Hero":"purify_index__showG176Hero--3-1JZ","showG169Hero":"purify_index__showG169Hero--Rvvdn"};